import { InjectionToken } from '@angular/core';

export const KILLSWITCH = new InjectionToken<any>('KILLSWITCH');
